module.exports = __webpack_public_path__ + "static/media/success.aad38cf8.svg";